module.exports = __webpack_public_path__ + "static/media/msd-npa2023.cf430948.png";